module.exports = __webpack_public_path__ + "static/Icons_homeloans_Inactive_large-1fdd3336597ccedca04286adc463ed9a.png";